import { Component } from 'react';

import './style.sass';
import StagesDesktop from './StagesDesktop';
import StagesMobile from './StagesMobile';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

class Stages extends Component {
    render() {
        return (
            <div className="stages">
                <div className="stages__inner">
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <CommonTitle className="stages__title">Этапы работы</CommonTitle>
                    </ScrollAnimation>
                    <StagesDesktop />
                    <StagesMobile />
                </div>
            </div>
        );
    }
}

export default Stages;
